import React from "react";
import "./sectors.css";

const Sectors = () => {
  const sectors = [
    {
      title: "GYM",
      img: "/assets/img/sectors/gym.png",
    },
    {
      title: "Mall & Retail Shops",
      img: "/assets/img/sectors/mall.png",
    },
    {
      title: "Industrial Sector",
      img: "/assets/img/sectors/industrial.png",
    },
    {
      title: "Hospitals & Healthcare",
      img: "/assets/img/sectors/hospital.png",
    },
    {
      title: "Showrooms",
      img: "/assets/img/sectors/showroom.png",
    },
    {
      title: "Office & Commercial Buildings",
      img: "/assets/img/sectors/offices.png",
    },
  ];

  return (
    <section className="sectors-section py-5">
      <div className="container-fluid px-0">
        <div className="row g-0">
          {/* Left Info Section */}
          <div className="col-lg-4 bg-danger text-white d-flex flex-column justify-content-center px-5 py-5">
            <h2 className="fw-bold mb-3" style={{ fontSize: "2.5rem" }}>
              Varied Industries and Fields We Serve
            </h2>
            <p style={{ lineHeight: "1.7" }}>
              Helperji provides services across multiple sectors, leveraging our expertise and specialization. We cater to renowned industries such as hospitals, malls, gyms, showrooms, factories, and offices.
            </p>
          </div>
          {/* Right Auto Scroll Section */}
          <div className="col-lg-8 bg-dark p-4">
            <div className="sectors-scroll">
              <div className="sectors-track">
                {/* Original List */}
                {sectors.map((item, index) => (
                  <div className="sector-card bg-white text-center shadow-sm" key={index}>
                    <img
                      src={item.img}
                      alt={item.title}
                      className="img-fluid rounded-top"
                    />
                    <div className="p-3">
                      <h6 className="fw-bold text-dark mb-0">{item.title}</h6>
                    </div>
                  </div>
                ))}

                {/* Cloned List (for infinite loop effect) */}
                {sectors.map((item, index) => (
                  <div
                    className="sector-card bg-white text-center shadow-sm"
                    key={`clone-${index}`}
                  >
                    <img
                      src={item.img}
                      alt={item.title}
                      className="img-fluid rounded-top"
                    />
                    <div className="p-3">
                      <h6 className="fw-bold text-dark mb-0">{item.title}</h6>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Sectors;